import { useQuery } from '@tanstack/react-query';
import { getTags } from '../services';
import { Tag } from 'features/common/types';

export const useTagsApi = () => {
	const {
		data: tags,
		isLoading,
		refetch,
	} = useQuery({
		queryKey: ['tags'],
		queryFn: getTags,
		initialData: [] as Tag[],
		select: (data): Tag[] => {
			// Ensure we always return an array
			if (Array.isArray(data)) return data;
			if (data && typeof data === 'object' && 'tags' in data) return (data as any).tags;
			return [];
		},
	});

	return {
		tags: Array.isArray(tags) ? tags : [],
		isLoading,
		refetch,
	};
};
